<template>
  <div style="width: 100%">
    <div class="checklist-question">
      <div class="question-wrap" :class="{ active: dropDown || isAllDropDown }">
        <div
          class="question-title-wrap"
          :class="{ 'bg-red': _remarkValidateRule && !remark, nodropDownToggle: nodropDownToggle }"
          @click="$_dropDownToggle()"
        >
          <div class="left">
            <div class="title">
              <WsText001 h5 bold>
                {{ quesNum }}
              </WsText001>
            </div>
            <div class="question-title">
              <WsText001 h4 bold :remove-style="removeStyle">
                {{ title }}
              </WsText001>
              <WsText001 v-if="subtitle && !hideSubtitle" class="mt-8" h5 light-gray>
                {{ subtitle }}
              </WsText001>
              <WsChips001 v-if="chips && chips.length" :value="chips" />
              <div v-if="isError && errorMessage.length" class="mt-12">
                <p v-for="(message, index) in errorMessage" :key="index" class="warning">
                  <i class="icon-info" />
                  <WsText001>
                    {{ message }}
                  </WsText001>
                </p>
              </div>
              <p v-if="_riskText" class="question-title_result">
                <!-- pass -->
                <i
                  v-if="quesResult && _riskIcon === 'pass'"
                  class="result-icon icon-check-circle-filled green"
                />
                <!-- Major -->
                <i
                  v-if="quesResult && _riskIcon === 'red'"
                  class="result-icon icon-info-filled red"
                />
                <!-- minor -->
                <i
                  v-if="quesResult && _riskIcon === 'yellow'"
                  class="result-icon icon-info-filled yellow"
                />
                <!-- ofi -->
                <i
                  v-if="quesResult && _riskIcon === 'blue'"
                  class="result-icon icon-info-filled blue"
                />
                <!-- 不適合 -->
                <i v-if="quesResult && _riskIcon === 'grey'" class="result-icon icon-cancel grey" />
                {{ $t(_riskText) }}
              </p>
              <WsText001 v-if="alertText && score" class="mt-8 question-title__alert">
                <i class="icon-info" />
                <!-- 風險：刑事責任、罰鍰 -->
                {{ $t(alertText) }}
              </WsText001>
              <WsText001 v-if="_remarkValidateRule && !remark" class="mt-8 question-title__alert">
                <i class="icon-edit-pencil" />
                {{ $t('尚未填寫備註') }}
              </WsText001>
              <WsText001 v-if="warningText" class="mt-8 question-title__alert">
                <i class="icon-info" />
                {{ $t(warningText) }}
              </WsText001>
            </div>
          </div>
          <div v-if="!nodropDownToggle" class="right">
            <ContentChip
              v-if="focusRadio.selected_condition === 1 && !hideFocus"
              medium-blue
              :text-label="$t('重點關注')"
            />
            <i v-if="dropDown || isAllDropDown" class="icon-unfold-less" />
            <i v-else class="icon-unfold-more" />
          </div>
        </div>
        <div v-if="loading" class="question-container">
          <DotLoading primary />
        </div>
        <slide-up-down v-else :active="dropDown || isAllDropDown" :duration="500">
          <ValidationObserver ref="formObserver" v-slot="{ invalid }">
            <LlValidateWatcher :errors="invalid" @input="$_isError($event)" />
            <div class="question-container">
              <div class="question-content">
                <LvStateRadioBtn
                  v-if="select"
                  v-model="focusRadio.selected_condition"
                  class="question-content__no-icon"
                  required
                  row
                  is-narrow
                  :title="$t('重點關注')"
                  :radio-name="radioName"
                  :radio-button-item="focusRadio"
                />
                <div v-if="quesType === 1 && changeQuesType" class="range-input ml-22">
                  <WsStateRangeInput001
                    class="mt-20"
                    :range-data="controlLimitData"
                    :lower-limit="parseFloat(specLimitData.lower)"
                    :upper-limit="parseFloat(specLimitData.upper)"
                    :lower-data-placeholder="$t('輸入下限')"
                    :upper-data-placeholder="$t('輸入上限')"
                    :custom-messages="controlLimitCustomMessages"
                    :title="$t('Control Limit (管制界線)')"
                    :pop-up-btn="$t('查看管制界線設定建議')"
                    :popup-title="$t('管制界線設定建議')"
                    :popup-content="controlLimitData.controlLimitSuggest"
                    :required="required"
                  />
                  <WsStateRangeInput001
                    class="mt-20 mb-20"
                    :range-data="specLimitData"
                    :lower-error-message="$t('合規界線下限不可大於管制界線')"
                    :upper-error-message="$t('合規界線上限不可小於管制界線')"
                    :lower-data-placeholder="$t('輸入下限')"
                    :upper-data-placeholder="$t('輸入上限')"
                    :custom-messages="specLimitCustomMessages"
                    :title="$t('Spec Limit (合規界線)')"
                    :pop-up-btn="$t('查看合規界線設定建議')"
                    :popup-title="$t('合規界線設定建議')"
                    :popup-content="specLimitData.specLimitSuggest"
                    :required="required"
                  />
                </div>
                <div v-if="quesType === 1 && quesResult" class="question-content_wrap ml-24">
                  <div class="question-content_content">
                    <div class="question-content_content-title-line">
                      <p class="question-content__text bold">
                        {{ $t('觀測值') }}
                      </p>
                    </div>
                    <p class="question-content__text mt-8">
                      {{ score }}
                    </p>
                  </div>
                </div>
                <div
                  v-if="quesType === 1 && !changeQuesType"
                  class="question-content_wrap ml-24 mt-20"
                >
                  <div class="question-content_content">
                    <div class="question-content_content-title-line">
                      <p class="question-content__text bold">
                        {{ $t('Control Limit (管制界線)') }}
                      </p>
                    </div>
                    <p class="question-content__text mt-8">
                      {{ controlLimitData.lower }} - {{ controlLimitData.upper }}
                    </p>
                  </div>
                </div>
                <div
                  v-if="quesType === 1 && !changeQuesType"
                  class="question-content_wrap ml-24 mt-20"
                >
                  <div class="question-content_content">
                    <div class="question-content_content-title-line">
                      <p class="question-content__text bold">
                        {{ $t('Spec Limit (合規界線)') }}
                      </p>
                    </div>
                    <p class="question-content__text mt-8">
                      {{ specLimitData.lower }} - {{ specLimitData.upper }}
                    </p>
                  </div>
                </div>
                <div v-if="isInStats !== undefined" class="question-content_wrap mt-20 ml-24">
                  <div class="question-content_content">
                    <div class="question-content_content-title-line">
                      <p class="question-content__text bold">
                        {{ $t('列入結果統計、不合規排行榜、今日點檢結論') }}
                      </p>
                    </div>
                    <div class="mt-8">
                      <p class="question-content__text">
                        {{ isInStats ? $t('是') : $t('否') }}
                      </p>
                    </div>
                  </div>
                </div>
                <div v-if="newQuesType !== undefined" class="question-content_wrap mt-20 ml-24">
                  <div class="question-content_content">
                    <div class="question-content_content-title-line">
                      <p class="question-content__text bold">
                        {{ $t('題型') }}
                      </p>
                    </div>
                    <div class="mt-8">
                      <p class="question-content__text">
                        {{ $t(newQuesType.name) }}
                      </p>
                    </div>
                  </div>
                </div>
                <!-- <div v-if="option !== undefined" class="question-content_wrap mt-20 ml-24">
                  <div class="question-content_content">
                    <div class="question-content_content-title-line">
                      <p class="question-content__text bold">
                        {{ $t('選項組合') }}
                      </p>
                    </div>
                    <div class="mt-8">
                      <p class="question-content__text">
                        {{ $t(option.name) }}
                      </p>
                    </div>
                  </div>
                </div> -->
                <div v-if="optionList !== undefined" class="question-content_wrap mt-20 ml-24">
                  <div class="question-content_content">
                    <div class="question-content_content-title-line">
                      <p class="question-content__text bold">
                        {{ $t('選項') }}
                      </p>
                    </div>
                    <div class="mt-8">
                      <p class="question-content__text">
                        <LvInfoQuesOptionList :list="optionList" />
                      </p>
                    </div>
                  </div>
                </div>
                <div v-if="condition !== undefined" class="question-content_wrap mt-20 ml-24">
                  <div class="question-content_content">
                    <div class="question-content_content-title-line">
                      <p class="question-content__text bold">
                        {{ $t('條件設定方式') }}
                      </p>
                    </div>
                    <div class="mt-8">
                      <p class="question-content__text">
                        {{ $t(condition.name) }}
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  v-if="
                    controlLimitData !== undefined &&
                    controlLimitData.lower !== undefined &&
                    controlLimitData.upper !== undefined
                  "
                  class="question-content_wrap ml-24 mt-20"
                >
                  <div class="question-content_content">
                    <div class="question-content_content-title-line">
                      <p class="question-content__text bold">
                        {{ $t('Control Limit (管制界線)') }}
                      </p>
                    </div>
                    <p class="question-content__text mt-8">
                      {{ controlLimitData.lower }} - {{ controlLimitData.upper }}
                    </p>
                  </div>
                </div>
                <div
                  v-if="
                    specLimitData !== undefined &&
                    specLimitData.lower !== undefined &&
                    specLimitData.upper !== undefined
                  "
                  class="question-content_wrap ml-24 mt-20"
                >
                  <div class="question-content_content">
                    <div class="question-content_content-title-line">
                      <p class="question-content__text bold">
                        {{ $t('Spec Limit (合規界線)') }}
                      </p>
                    </div>
                    <p class="question-content__text mt-8">
                      {{ specLimitData.lower }} - {{ specLimitData.upper }}
                    </p>
                  </div>
                </div>
                <div v-if="conditionList !== undefined" class="question-content_wrap mt-20 ml-24">
                  <div class="question-content_content">
                    <div class="question-content_content-title-line">
                      <p class="question-content__text bold">
                        {{ $t('條件式') }}
                      </p>
                    </div>
                    <div class="mt-8">
                      <p class="question-content__text">
                        <LvInfoQuesConditionList :list="conditionList" />
                      </p>
                    </div>
                  </div>
                </div>
                <div v-if="unit !== undefined" class="question-content_wrap mt-20 ml-24">
                  <div class="question-content_content">
                    <div class="question-content_content-title-line">
                      <p class="question-content__text bold">
                        {{ $t('單位') }}
                      </p>
                    </div>
                    <div class="mt-8">
                      <p class="question-content__text">
                        {{ $t(unit) }}
                      </p>
                    </div>
                  </div>
                </div>
                <div class="question-content_wrap mt-20">
                  <div class="icon">
                    <i :class="contentIcon" />
                  </div>
                  <div class="question-content_content">
                    <div class="question-content_content-title-line">
                      <p class="question-content__text bold">
                        {{ textLabel }}
                      </p>
                      <WsButton001
                        v-if="editable && !editablActive"
                        non-min-width
                        out-line
                        flat-button
                        @click="$_editableBtnClick()"
                      >
                        {{ $t('編輯備註') }}
                      </WsButton001>
                      <LvUploadFileBtn
                        v-if="editable && editablActive"
                        multiple
                        type="text"
                        btnText="附件"
                        :uploadModule="uploadModule"
                        :selectedFileList="C_images"
                        @input="$_onInput($event, 'C_images')"
                      />
                    </div>
                    <ValidationProvider :rules="_remarkValidateRule ? 'required' : ''">
                      <input type="hidden" :value="remark" />
                    </ValidationProvider>
                    <InputListCard v-if="editablActive" class="mt-12">
                      <WsInputTextareaButton001
                        v-model="C_remark"
                        :placeholder="$t('輸入')"
                        :min-height="90"
                        :rules="_remarkValidateRule ? 'required' : ''"
                      />
                      <div v-if="C_images.length > 0">
                        <LvFileList
                          outline
                          twoItem
                          showDeleteBtn
                          :value="C_images"
                          :marginTop="20"
                          :module="uploadModule"
                          @go-to="$_onGoToFile($event)"
                          @delete-file="$_onDeleteImages($event)"
                        />
                      </div>
                      <div class="bottom-btn-list mt-20">
                        <WsButton001
                          out-line
                          non-min-width
                          flat-button
                          @click="$_editableBtnCancel()"
                        >
                          {{ $t('取消') }}
                        </WsButton001>
                        <WsButton001
                          class="ml-20"
                          non-min-width
                          flat-button
                          @click="$_editableBtnSubmit()"
                        >
                          {{ $t('完成') }}
                        </WsButton001>
                      </div>
                    </InputListCard>
                    <div v-else class="mt-8">
                      <p class="question-content__text">
                        {{ remark ? remark : '無' }}
                      </p>
                      <div v-if="images && images.length" class="question-content_files">
                        <LvFileList
                          twoItem
                          :value="images"
                          :marginTop="20"
                          @go-to="$_onGoToFile($event)"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="annex && attaches && attaches.length" class="download-wrap ml20">
                  <div class="download-content">
                    <div class="download-list">
                      <LvDownloadFileBtn
                        v-for="(attach, attachIndex) in attaches"
                        :key="`attach_${attachIndex}`"
                        :id="attach.id"
                        :num="attachIndex"
                        :url="attach.url"
                        :name="attach.name"
                        :download="attach.hasScope"
                        :fileType="attach.fileType"
                        :hasScope="attach.hasScope"
                        :isSystem="attach.isSystem"
                        :chipList="attach.chipList"
                        :versionNumber="attach.versionNumber"
                        :showMoreBtn="attach.showMoreBtn"
                        :showDownloadBtn="attach.showDownloadBtn"
                        :isClickable="attach.isClickable"
                        :isImageViewable="_isImageViewable"
                        class="download-item"
                        @go-to="$_onGoToFile($event)"
                      />
                    </div>
                  </div>
                </div>
                <div v-if="annex && tempAttaches && tempAttaches.length" class="download-wrap ml20">
                  <div class="download-content">
                    <div class="download-list">
                      <LvDownloadFileBtn
                        v-for="(attach, attachIndex) in tempAttaches"
                        :key="`tempAttach_${attachIndex}`"
                        :id="attach.id"
                        :num="attachIndex"
                        :url="attach.url"
                        :name="attach.name"
                        :download="attach.hasScope"
                        :fileType="attach.fileType"
                        :hasScope="attach.hasScope"
                        :isSystem="attach.isSystem"
                        :chipList="attach.chipList"
                        :versionNumber="attach.versionNumber"
                        :showMoreBtn="attach.showMoreBtn"
                        :showDownloadBtn="attach.showDownloadBtn"
                        :isClickable="attach.isClickable"
                        :isImageViewable="_isImageViewable"
                        class="download-item"
                        @go-to="$_onGoToFile($event)"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="(lawList && lawList.length > 0) || _riskSignal.length > 0" class="links">
                <i class="icon-nav-law-outline" />
                <div class="link-content">
                  <WsText001 h6 bold>
                    {{ lawTitle }}
                  </WsText001>
                  <LlLink
                    v-for="(law, lawIndex) in lawList"
                    :key="lawIndex"
                    :text-label="law.text"
                    @click="$_onClickQuesLawLink(law)"
                  />
                  <TextIconList v-if="_riskSignal.length > 0" :icon-list="_riskSignal" />
                </div>
              </div>
              <div v-if="guidelineList && guidelineList.length > 0" class="links">
                <div class="link-content ml-24">
                  <WsText001 h6 bold>
                    {{ $t(guidelineTitle) }}
                  </WsText001>
                  <LlLink
                    v-for="(guideline, guidelineIndex) in guidelineList"
                    :key="guidelineIndex"
                    :textLabel="guideline.title"
                    @click="$_onClickRelatedGuideline(guideline)"
                  />
                </div>
              </div>
              <InputListCard v-if="ocapEdit" class="mt-20">
                <div class="input-item ml-24">
                  <WsText001 class="mt-20" h5 bold>
                    {{ textLabelOcap }}
                  </WsText001>
                  <div class="input mt-8">
                    <WsInputTextareaButton001
                      :value="C_ocapRemark"
                      :min-height="134"
                      :placeholder="$t('輸入')"
                      @input="$_ocapRemark($event)"
                    />
                  </div>
                </div>
                <div class="input-item ml-24">
                  <WsText001 class="mt-20" h5 bold>
                    {{ attachTitleOcap }}
                  </WsText001>
                  <div class="file-list mt-8">
                    <div
                      v-for="(attach, attachIndex) in ocapAttaches"
                      :key="attachIndex"
                      class="file"
                    >
                      <FileDownloadButton
                        upload
                        :text-label="attach.url"
                        :isloading="attach.isloading"
                        @deleteFile="$_deleteFile(attach)"
                      />
                    </div>
                    <div class="file">
                      <UploadFileButton
                        :value="ocapAttaches"
                        multiple
                        :upload-url="uploadFileOcapUrl"
                        :factory="_currentFactoryId"
                        @input="$_uploadChange($event)"
                      />
                    </div>
                  </div>
                </div>
              </InputListCard>
              <div v-if="ocapContent && !ocapEdit" class="question-content">
                <div class="question-content_wrap ml-24">
                  <div class="icon">
                    <i :class="ocapIcon" />
                  </div>
                  <div class="question-content_content">
                    <div class="question-content_content-title-line">
                      <p class="question-content__text bold">
                        {{ textLabelOcap }}
                      </p>
                    </div>
                    <p class="question-content__text mt-8">
                      {{ C_ocapRemark ? C_ocapRemark : ocapRemark ? ocapRemark : $t('無') }}
                    </p>
                    <div v-if="ocapAttaches.length > 0" class="download-wrap ml20">
                      <div class="download-content">
                        <div class="download-list">
                          <div
                            v-for="(file_e, file_k) in ocapAttaches"
                            :key="file_k"
                            class="download-item"
                          >
                            <FileDownloadButton narrow :text-label="file_e.url" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="hasBottomBtn" class="bottom-btn">
                <slot name="bottom-btn" />
                <WsTextButton001 trailing-icon="icon-chevron-forward" @click="$_bottomBtnClick()">
                  {{ bottonBtnText }}
                </WsTextButton001>
              </div>
            </div>
          </ValidationObserver>
        </slide-up-down>
      </div>
      <div v-if="select" class="select-tool">
        <slot name="select" />
      </div>
    </div>
  </div>
</template>
<script>
import { ValidationProvider } from 'vee-validate';
import H_file from '@/helpers/file';

export default {
  name: 'ChecklistQuestion002',
  components: {
    ValidationProvider,
  },
  props: {
    warningText: {
      type: String,
      default: '',
    },
    changeQuesType: {
      type: Boolean,
      default: false,
    },
    ocapEdit: {
      type: Boolean,
      default: false,
    },
    ocapContent: {
      type: Boolean,
      default: false,
    },
    quesType: {
      type: Number,
      default: 0, //quality質===0,quantity量===1
    },
    bottonBtnText: {
      type: String,
      default: '',
    },
    select: {
      type: Boolean,
      default: false,
    },
    edit: {
      type: Boolean,
      default: false,
    },
    textLabel: {
      type: String,
      default: '',
    },
    contentIcon: {
      type: String,
      default: '',
    },
    annex: {
      type: Boolean,
      default: false,
    },
    quesNum: {
      type: [Number, String],
      default: 0,
    },
    level: {
      type: Number,
      default: 0,
    },
    title: {
      type: String,
      default: '',
    },
    score: {
      type: [Number, String],
      default: 0,
    },
    quesResult: {
      type: Boolean,
      default: false,
    },
    remark: {
      type: String,
      default: '',
    },
    editable: {
      type: Boolean,
      default: false,
    },
    images: {
      type: Array,
      default() {
        return [];
      },
    },
    attaches: {
      type: Array,
      default() {
        return [];
      },
    },
    lawList: {
      type: Array,
    },
    subtitle: {
      type: String,
      default: '',
    },
    hideSubtitle: {
      type: Boolean,
      default: false,
    },
    hasBottomBtn: {
      type: Boolean,
      default: false,
    },
    downloadTitle: {
      type: String,
      default() {
        return this.$t('附件');
      },
    },
    lawTitle: {
      type: String,
      default() {
        return this.$t('法規依據');
      },
    },
    guidelineTitle: {
      type: String,
      default: '相關內規',
    },
    riskSignal: {
      type: Array,
      default() {
        return [];
      },
    },
    focus: {
      type: Number,
      default: 0,
    },
    hideFocus: {
      type: Boolean,
      default: false,
    },
    radioName: {
      type: String,
      default: '',
    },
    focusRadio: {
      type: Object,
      default() {
        return {
          selected_condition: 0,
          buttonItems: [
            {
              id: 1,
              value: 'true',
              textLabel: '是',
            },
            {
              id: 0,
              value: 'false',
              textLabel: '否',
            },
          ],
        };
      },
    },
    alertText: {
      type: String,
      default: '',
    },
    uploadUrl: {
      type: String,
      default: '',
    },
    limitData: {
      type: Object,
      default() {
        return {};
      },
    },
    controlLimitData: {
      type: Object,
      default() {
        return {};
      },
    },
    specLimitData: {
      type: Object,
      default() {
        return {};
      },
    },
    textLabelOcap: {
      type: String,
      default: 'OCAP',
    },
    attachTitleOcap: {
      type: String,
      default() {
        return this.$t('OCAP附件');
      },
    },
    uploadFileOcapUrl: {
      type: String,
      default: '',
    },
    ocapAttaches: {
      type: Array,
      default() {
        return [];
      },
    },
    ocapRemark: {
      type: String,
      default: '',
    },
    ocapIcon: {
      type: String,
      default: '',
    },
    nodropDownToggle: {
      type: Boolean,
      default: false,
    },
    removeStyle: {
      type: Boolean,
      default: false,
    },
    remarkValidateRule: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    isAllDropDown: {
      type: Boolean,
      default: false,
    },
    uploadModule: {
      type: String,
    },
    tempAttaches: {
      type: Array,
    },
    chips: {
      type: Array,
    },
    isInStats: {
      type: Number,
    },
    newQuesType: {
      type: Object,
    },
    option: {
      type: Object,
    },
    optionList: {
      type: Array,
    },
    condition: {
      type: Object,
    },
    conditionList: {
      type: Array,
    },
    unit: {
      type: String,
    },
    guidelineList: {
      type: Array,
    },
  },

  data() {
    return {
      isError: false,
      loading: false,
      errorMessage: [],
      selected: false,
      dropDown: false,
      editing: false,
      inputQuestionTitle: '',
      inputQuestionContent: '',
      C_remark: '',
      C_images: [],
      C_ocapRemark: '',
      editablActive: false,
      hasFetch: false,
      controlLimitCustomMessages: {
        customedMinValue: this.$t('管制界線下限不可小於合規界線'),
        customedMaxValue: this.$t('管制界線上限不可大於合規界線'),
        max_value: this.$t('管制界線下限不可大於管制界線上限'),
        min_value: this.$t('管制界線上限不可小於管制界線下限'),
      },
      specLimitCustomMessages: {
        customedMinValue: this.$t('合規界線下限不可大於管制界線'),
        customedMaxValue: this.$t('合規界線上限不可小於管制界線'),
        max_value: this.$t('合規界線下限不可大於合規界線上限'),
        min_value: this.$t('合規界線上限不可小於合規界線下限'),
      },
    };
  },

  computed: {
    _currentFactoryId() {
      return this.$store.state.app.factoryId;
    },
    _riskText() {
      if (!this.score) {
        return '';
      }
      if (this.quesType === 1) {
        //量性題
        const upperMiddle =
          (parseFloat(this.controlLimitData.upper) + parseFloat(this.specLimitData.upper)) / 2;
        const lowerMiddle =
          (parseFloat(this.controlLimitData.lower) + parseFloat(this.specLimitData.lower)) / 2;
        if (
          this.controlLimitData.lower <= this.score &&
          this.score <= this.controlLimitData.upper
        ) {
          return '合規';
        } else {
          if (this.score > upperMiddle || this.score < lowerMiddle) {
            return '不合規';
          }
          if (
            (lowerMiddle <= this.score && this.score < this.controlLimitData.lower) ||
            (this.controlLimitData.upper < this.score && this.score <= upperMiddle)
          ) {
            return '中度異常';
          } else {
            return '';
          }
        }
      }
      if (this.score === 25) {
        return '合規';
      } else {
        if (this.score === 23) {
          return 'Major(主要缺失)';
        }
        if (this.score === 22) {
          return 'Minor(次要缺失)';
        }
        if (this.score === 21) {
          return 'OFI(待改善)';
        }
        if (this.score === 20) {
          return '不適用';
        } else {
          return '';
        }
      }
    },
    _riskIcon() {
      if (!this.score) {
        return '';
      }
      let riskIcon;
      if (this.quesType === 1) {
        //量性題
        const upperMiddle =
          (parseFloat(this.controlLimitData.upper) + parseFloat(this.specLimitData.upper)) / 2;
        const lowerMiddle =
          (parseFloat(this.controlLimitData.lower) + parseFloat(this.specLimitData.lower)) / 2;
        if (
          this.controlLimitData.lower <= this.score &&
          this.score <= this.controlLimitData.upper
        ) {
          riskIcon = 'pass';
        } else {
          if (this.score > upperMiddle || this.score < lowerMiddle) {
            riskIcon = 'red';
          }
          if (
            (lowerMiddle <= this.score && this.score < this.controlLimitData.lower) ||
            (this.controlLimitData.upper < this.score && this.score <= upperMiddle)
          ) {
            riskIcon = 'yellow';
          } else {
            return riskIcon;
          }
        }
      }
      if (this.score === 25) {
        riskIcon = 'pass';
      } else if (this.score === 23) {
        riskIcon = 'red';
      } else if (this.score === 22) {
        riskIcon = 'yellow';
      } else if (this.score === 21) {
        riskIcon = 'blue';
      } else if (this.score === 20) {
        riskIcon = 'grey';
      }
      return riskIcon;
    },
    _remarkValidateRule() {
      if (!this.remarkValidateRule) return false;
      if (this.quesType === 1) {
        //量性題
        const upperMiddle =
          (parseFloat(this.controlLimitData.upper) + parseFloat(this.specLimitData.upper)) / 2;
        const lowerMiddle =
          (parseFloat(this.controlLimitData.lower) + parseFloat(this.specLimitData.lower)) / 2;
        if (
          this.controlLimitData.lower <= this.score &&
          this.score <= this.controlLimitData.upper
        ) {
          return false;
        } else {
          if (this.score > upperMiddle || this.score < lowerMiddle) {
            return true;
          }
          if (
            (lowerMiddle <= this.score && this.score < this.controlLimitData.lower) ||
            (this.controlLimitData.upper < this.score && this.score <= upperMiddle)
          ) {
            return true;
          } else {
            return false;
          }
        }
      }
      if (this.score === 21 || this.score === 22 || this.score === 23 || this.score === 20) {
        return true;
      } else return false;
    },
    _riskSignal() {
      if (!this.riskSignal) return [];
      const _riskSignal = [];
      this.riskSignal.forEach(risk => {
        if (!risk.length) return;
        risk.forEach(item => {
          _riskSignal.push(item);
        });
      });
      return _riskSignal;
    },
    _isImageViewable() {
      return this.$store.state.app.factory.isImageViewable;
    },
  },

  watch: {
    focusRadio: {
      immediate: true,
      deep: true,
      handler(newValue) {
        this.$emit('input', newValue.selected_condition);
      },
    },
    remark() {
      this.C_remark = this.remark;
    },
    ocapRemark() {
      this.C_ocapRemark = this.ocapRemark;
    },
    images() {
      this.C_images = [];
      this.images.forEach(image => {
        if (image) {
          this.C_images.push(image);
        }
      });
    },
  },

  mounted() {
    this.focusRadio.selected_condition = this.focus;
    this.$_getEdibleContent();
  },

  methods: {
    $_dropDownToggle() {
      if (this.nodropDownToggle) {
        return;
      }
      this.dropDown = !this.dropDown;
      if (this.dropDown && !this.hasFetch) {
        //when question is dropdown,fetch question content
        this.$emit('fetch-question');
        this.hasFetch = true;
      }
    },
    $_onClickQuesLawLink(law) {
      this.$emit('law-click', law);
    },
    $_bottomBtnClick() {
      this.$emit('bottom-btn-click');
    },
    $_editableBtnClick() {
      this.$_getEdibleContent();
      this.editablActive = true;
    },
    $_editableBtnCancel() {
      this.editablActive = false;
    },
    $_getEdibleContent() {
      this.C_remark = this.remark;
      this.C_ocapRemark = this.ocapRemark;
      this.C_images = [];
      this.images.forEach(image => {
        if (image) {
          this.C_images.push(image);
        }
      });
    },
    $_editableBtnSubmit() {
      const remark = {};
      remark.images = this.C_images;
      remark.remark = this.C_remark;
      this.$emit('editable-btn-submit', remark);
      //送出但還沒出傳去
      this.$_editableBtnCancel();
    },
    $_deleteImageFromRemark(index, imageList) {
      imageList.splice(index, 1);
    },
    $_uploadChange($event) {
      this.$emit('ocap-change', $event);
    },
    $_deleteFile(index) {
      this.$emit('ocap-delete', index);
    },
    $_ocapRemark($event) {
      this.$emit('ocap-remark', $event);
    },
    $_isError($event) {
      this.isError = $event;
      if (this.isError) {
        this.errorMessage = [`${this.$t('必填資料尚未填寫完整')}`];
      } else {
        this.errorMessage = [''];
      }
    },
    $_loadingStart() {
      this.loading = true;
    },
    $_loadingEnd() {
      this.loading = false;
    },
    $_onGoToFile($event) {
      H_file.goToFile($event);
    },
    $_onInput($event, key) {
      let value = $event;
      if (key === 'C_images') {
        value = this.C_images && this.C_images.length ? [...this.C_images, ...$event] : $event;
      }
      this[key] = value;
    },
    $_onDeleteImages(index) {
      this.C_images.splice(index, 1);
    },
    $_onClickRelatedGuideline(guideline) {
      this.$emit('guideline-click', guideline);
    },
  },
};
</script>
<style lang="scss">
@import '@/assets/scss/component/checklist-question';
</style>
